/**
 * Utilidades para formateo de datos
 */

/**
 * Formatea un número como moneda (EUR)
 * @param {number} value - El valor a formatear
 * @returns {string} El valor formateado como moneda
 */
export const formatCurrency = (value) => {
  const formatter = new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency: 'EUR'
  });
  
  return formatter.format(value || 0);
}; 